module.exports = __webpack_public_path__ + "img/server_bmh1.ddc2fbb1.png";